import './style.css';

import normalizeWheel from 'normalize-wheel-es';

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls';
import { FlyControls } from 'three/examples/jsm/controls/FlyControls';
// import { Vector2, Vector3 } from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';

import GUI, { FunctionController } from 'lil-gui';
import Stats from 'three/examples/jsm/libs/stats.module.js';

import { gsap, random } from 'gsap';
import { Observer } from 'gsap/Observer';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(Observer);
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

import axios from 'axios';

import data from '../src/data.js';

// ?

//////////////////////////////////////////////////////////
var is_debug = false;

if (is_debug) {
    console.log('data', data);
}

/// CHECK SAFARI
var isSafariDesktop = navigator.vendor.match(/apple/i) ? (window.innerWidth > 1024 ? true : false) : false;

if (is_debug) {
    console.log('isSafariPC', isSafariDesktop);
}

//// CHECK WINDOWS
function getOS() {
    let userAgent = window.navigator.userAgent.toLowerCase(),
        macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
        windowsPlatforms = /(win32|win64|windows|wince)/i,
        iosPlatforms = /(iphone|ipad|ipod)/i,
        os = null;

    if (macosPlatforms.test(userAgent)) {
        os = 'macos';
    } else if (iosPlatforms.test(userAgent)) {
        os = 'ios';
        window.createImageBitmap = undefined;
    } else if (windowsPlatforms.test(userAgent)) {
        os = 'windows';
    } else if (/android/.test(userAgent)) {
        os = 'android';
    } else if (!os && /linux/.test(userAgent)) {
        os = 'linux';
    }

    return os;
}

var os = getOS();
var isEdge = /Edg/.test(navigator.userAgent);

if (is_debug) {
    console.log(os, isEdge);
}

/// STATS and GUI

if (is_debug) {
    var stats = Stats();
    stats.dom.setAttribute('class', 'stats-gui');
    document.body.appendChild(stats.dom);
}

var contentui_open = false;
var claimui_open = false;
var credit_open = false;
var add_gui = true;

if (add_gui) {
    var gui = new GUI();
    gui.close();
    if (window.innerWidth < 768) {
        gui.close();
    }
}

////
var bgm = document.querySelector('.bgm');
var sound_tap = new Audio('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/audio/sound-tap.mp3');
sound_tap.volume = 1;
var sound_token = new Audio('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/audio/sound-token-tap.mp3');
sound_token.volume = 1;

function playSoundEffect(soundtoplay) {
    if (document.querySelector('.ui-sound').getAttribute('data-sound') == 'off') return;
    if (soundtoplay) {
        soundtoplay.play();
    }
}

// GLOBAL VARS
var scene, renderer, camera;
var camera_position;
var model_outside;
var mixer;

var claim_total = 6;
var claim_progress = 0;
var claim_complete = false;

var active_room = 0;

let INTERSECTED;
const raycaster = new THREE.Raycaster();
raycaster.far = 2000;
const pointer = new THREE.Vector2(-2, -2);

var params = {
    target_scrolly: 0,
    current_scrolly: 0,
    ease_scrolly: 0.075,
    scrollspeed: 24000,
    speed_multiplier: 1,
    mouse: {
        target_x: 0,
        current_x: 0,
        target_y: 0,
        current_y: 0,
        ease: 0.03,
    },
    frametime: 0,
    cameraFOV: window.innerWidth > 768 ? 80 : 100,
    frametime_steady: 0,
    frametime_boutique: 2.49846,
    frametime_player: 9.150545,
    frametime_beauty: 13.40074,
    frametime_kids: 18.1584,
    frametime_golf: 25.10948369799279,
    frametime_outside: 28.526,
    frametime_end: 31.5,
    frametime_staticstart: 34.8,
    frametime_end2: 39.6,
    jumpto_steady: function () {
        params.frametime = 0;
        updateSceneFromGUI();
    },
    jumpto_boutique: function () {
        params.frametime = params.frametime_boutique;
        updateSceneFromGUI();
    },
    jumpto_player: function () {
        params.frametime = params.frametime_player;
        updateSceneFromGUI();
    },
    jumpto_beauty: function () {
        params.frametime = params.frametime_beauty;
        updateSceneFromGUI();
    },
    jumpto_kids: function () {
        params.frametime = params.frametime_kids;
        updateSceneFromGUI();
    },
    jumpto_golf: function () {
        params.frametime = params.frametime_golf;
        updateSceneFromGUI();
    },
    jumpto_end: function () {
        params.frametime = params.frametime_end;
        updateSceneFromGUI();
    },
    autoScroll: false,
    alreadyApply: false,
};

if (add_gui) {
    gui.add(params, 'alreadyApply').onChange(updateSceneFromGUI);
    gui.add(params, 'autoScroll').onChange(updateSceneFromGUI);
    var controller_timeframe = gui.add(params, 'frametime', 0.0, 46, 0.0001).onChange(updateSceneFromGUI);
    gui.add(params, 'cameraFOV', 40, 120, 0.05).onChange(updateSceneFromGUI);
    gui.add(params, 'jumpto_steady').onChange(updateSceneFromGUI);
    gui.add(params, 'jumpto_boutique').onChange(updateSceneFromGUI);
    gui.add(params, 'jumpto_player').onChange(updateSceneFromGUI);
    gui.add(params, 'jumpto_beauty').onChange(updateSceneFromGUI);
    gui.add(params, 'jumpto_kids').onChange(updateSceneFromGUI);
    gui.add(params, 'jumpto_golf').onChange(updateSceneFromGUI);
    gui.add(params, 'jumpto_end').onChange(updateSceneFromGUI);
}

// LOADING VARS
var loaded_models = 0;
// var total_models = 8;
var total_models = 8;
var all_loaded = false;
var first_show = true;

// EE VARS

var all_contents_arr = [];
var ee_arr = [];
var claimed_arr = [];

// tooltip

var tooltip_arr = [];

///////////////////

// Dom
var domWebGL = document.createElement('div');
domWebGL.setAttribute('class', 'three-canvas-wrap');
document.body.appendChild(domWebGL);

// Scene
scene = new THREE.Scene();
// scene.background = new THREE.Color(0xffffff);

// Renderer
if (os == 'ios') {
    console.log('is ios');
    renderer = new THREE.WebGL1Renderer({ alpha: true, antialias: true });
} else {
    renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
}
renderer.setClearColor(0x000000, 0);
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setPixelRatio(window.devicePixelRatio);
renderer.powerPreference = 'high-performance';
domWebGL.appendChild(renderer.domElement);

// Setup
// const camera_group = new THREE.Group();
camera = new THREE.PerspectiveCamera(90, window.innerWidth / window.innerHeight, 1, 100000);
camera.aspect = window.innerWidth / window.innerHeight;
camera.updateProjectionMatrix();

// const controls = new FlyControls(camera, renderer.domElement);
const controls = null;
if (controls) {
    camera.position.z = 10;
}

// LIGHTS

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
scene.add(directionalLight);

const dirlight_helper = new THREE.DirectionalLightHelper(directionalLight, 100);
scene.add(dirlight_helper);

//// ENVMAP

const hdrEquirect = new RGBELoader().load('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/textures/environmentMaps/empty_warehouse_01_rsz.hdr', () => {
    hdrEquirect.mapping = THREE.EquirectangularReflectionMapping;
});

const textureLoader = new THREE.TextureLoader();
const modelLoader = new GLTFLoader();
const dracoLoader = new DRACOLoader();
// dracoLoader.setDecoderPath('js/three/draco/');
dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
modelLoader.setDRACOLoader(dracoLoader);

////// SETUP BILLBOARD TOOLTIPS

var tooltip_geometry = new THREE.PlaneGeometry(15, 15, 1);
var tooltip_material = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    side: 0,
    map: textureLoader.load('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/ui/tooltip-80.png'),
    transparent: true,
    alphaTest: 0.5,
});
// tooltip_material.map.anisotropy = 0;
tooltip_material.map.magFilter = THREE.NearestFilter;
tooltip_material.map.minFilter = THREE.NearestFilter;

var tooltip_material2 = tooltip_material.clone();
tooltip_material2.map = textureLoader.load('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/ui/tooltip-140.png');

////// LOAD GLTF -  OUTSIDE MODEL
modelLoader.load(
    // resource URL
    'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/models/compressed/outside.glb',
    // './models/Musinsa_Outside_0428.glb',
    // called when the resource is loaded
    function (gltf) {
        if (is_debug) {
            console.log('model loaded: outsideshell ', gltf);
        }
        model_outside = gltf.scene;

        scene.add(model_outside);

        model_outside.traverse(function (child) {
            // if ( object.material ) materials.add( object.material );
            if (child.type == 'Mesh') {
                if (child.name.includes('Outside')) {
                    var wall_map = child.material.map;
                    var wall_color = child.material.color;
                    var material_outside = new THREE.MeshBasicMaterial({
                        color: wall_color,
                        map: wall_map,
                        side: 0,
                        // opacity: 0,
                        // transparent: true,
                    });
                    child.material = material_outside;
                }
            }
            // console.log(object);
        });

        checkLoadedState();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log(xhr);
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

////// LOAD GLTF -  BAKED CAMERA
var camera_animations;

modelLoader.load(
    // resource URL
    'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/models/Camera_0617.glb',
    // called when the resource is loaded
    function (gltf) {
        if (!controls) {
            if (is_debug) {
                console.log('model loaded: camera glb ', gltf);
            }

            camera = gltf.cameras[0];
            camera.near = 1;
            camera.fov = params.cameraFOV;
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();

            scene.add(gltf.scene);

            mixer = new THREE.AnimationMixer(gltf.scene);

            camera_animations = gltf.animations;
            if (is_debug) {
                console.log('camera anims', camera_animations);
            }
            camera_animations.forEach((clip) => {
                mixer.clipAction(clip).play();
            });

            if (add_gui) {
                controller_timeframe.max(camera_animations[0].duration);
            }
        }
        checkLoadedState();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

/////////////

/////////////
////// LOAD GLTF -  STEADY SELLER

var room_steadyseller;

modelLoader.load(
    // resource URL
    'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/models/compressed/steady.glb',
    // './models/Steady_seller_0615_03.glb',
    // called when the resource is loaded
    function (gltf) {
        room_steadyseller = gltf.scene;
        if (is_debug) {
            console.log('model loaded: steadyseller ', gltf);
        }
        scene.add(room_steadyseller);

        params.jumpto_steady();

        var steady_ceiling;

        var tooltip_room_grp = new THREE.Group();
        tooltip_room_grp.quaternion.copy(room_steadyseller.children[0].quaternion);
        tooltip_room_grp.position.copy(room_steadyseller.children[0].position);
        scene.add(tooltip_room_grp);

        room_steadyseller.traverse(function (child) {
            if (child.type == 'Mesh') {
                var copy_emissivemap = child.material.emissiveMap;
                if (copy_emissivemap) {
                    // copy_emissivemap.encoding = THREE.sRGBEncoding;
                    copy_emissivemap.encoding = THREE.LinearEncoding;
                }
                var material_steadyseller = new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    map: copy_emissivemap,
                    side: 0,
                });

                if (child.name == 'SteadySeller_1') {
                    // IF LIGHT BOX

                    var material_light = new THREE.MeshBasicMaterial({
                        color: 0xffffff,
                        map: copy_emissivemap,
                        // opacity: 0.1,
                        // transparent: true,
                        side: 0,
                    });
                    child.material = material_light;
                    // var tl_blink_steadyseller = gsap.timeline({ repeat: -1, yoyo: true });
                    // tl_blink_steadyseller.to(child.material, { emissiveIntensity: 0.7, duration: 0.02 });
                } else if (child.name == 'Ceiling') {
                    // replace ceiling texture with tiled image
                    steady_ceiling = child;
                    // var texture_tileceiling = textureLoader.load('./textures/steady_tex/ceiling-tile2.jpg');
                    // texture_tileceiling.wrapS = THREE.RepeatWrapping;
                    // texture_tileceiling.wrapT = THREE.RepeatWrapping;
                    // texture_tileceiling.repeat.set(1, 7.8);
                    // // console.log(texture_tileceiling);
                    // texture_tileceiling.offset.y = 0.1;
                    // // texture_tileceiling.encoding = THREE.sRGBEncoding;

                    // var material_ceiling = new THREE.MeshBasicMaterial({
                    //     color: 0xffffff,
                    //     // color: 0xff0000,
                    //     map: texture_tileceiling,
                    //     transparent: false,
                    //     side: 0,
                    //     // wireframe: true,
                    // });
                    // child.material = material_ceiling;
                } else if (child.name.includes('Content')) {
                    //

                    var id_num = Number(child.name.slice(-2) == '09' ? '08' : child.name.slice(-2));
                    child._roomidx = 0;
                    child._contentidx = id_num;
                    // console.log('steady', child.name, id_num, child._contentidx);
                    child.material = material_steadyseller;

                    child.custom_x = null;
                    child.custom_y = null;
                    child.custom_z = 0;
                    child.custom_roty = 0;

                    if (id_num == 1) {
                        child.custom_x = -95;
                        child.custom_y = -80;
                    } else if (id_num == 2) {
                        child.custom_x = 115;
                        child.custom_y = -125;
                    } else if (id_num == 3) {
                        child.custom_y = -130;
                    }

                    // add tooltips
                    createTooltips(tooltip_room_grp, child, 0, id_num);
                } else if (child.name.includes('Logo')) {
                    material_steadyseller.color = child.material.emissive;
                    material_steadyseller.alphaMap = child.material.normalMap;
                    material_steadyseller.transparent = true;
                    child.material = material_steadyseller;
                } else {
                    //
                    child.material = material_steadyseller;
                }
            }
        });

        /// CREATE INSTANCE FLUO LIGHTBULBS

        const steady_fluo_count = 32;
        const dummy = new THREE.Object3D();
        const fluo_group = new THREE.Group();

        var steady_fluo_Geometry = new THREE.BoxGeometry(5, 5, 200);
        var steady_fluo_Material = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            side: 0,
        });
        var steady_fluo_Mesh = new THREE.InstancedMesh(steady_fluo_Geometry, steady_fluo_Material, steady_fluo_count);
        fluo_group.add(steady_fluo_Mesh);
        scene.add(fluo_group);

        fluo_group.quaternion.copy(room_steadyseller.children[0].quaternion);
        fluo_group.position.copy(room_steadyseller.children[0].position);

        // set instanced positiions
        var fluo_counter = 0;
        var z_counter = 0;
        function setFluoData(dummy, i) {
            var new_pos = new THREE.Vector3();

            new_pos.x = -164 + (i % 4) * 110;
            new_pos.y = 180;
            new_pos.z = -120 - z_counter * 270;

            dummy.position.copy(new_pos);

            dummy.updateMatrix();
            steady_fluo_Mesh.setMatrixAt(i, dummy.matrix);

            if (fluo_counter + 1 > 3) {
                fluo_counter = 0;
                z_counter++;
            } else {
                fluo_counter++;
            }
        }
        for (let i = 0; i < steady_fluo_count; i++) {
            setFluoData(dummy, i);
        }

        checkLoadedState();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

////////////////
////// LOAD GLTF -  BOUTIQUE SCENE

var room_boutique;

modelLoader.load(
    // resource URL

    'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/models/Boutique_0719_03.glb',
    // './models/Boutique_0719_03.glb',
    // called when the resource is loaded
    function (gltf) {
        if (is_debug) {
            console.log('model loaded: boutique ', gltf);
        }
        room_boutique = gltf.scene;
        scene.add(room_boutique);

        params.jumpto_boutique();

        var tooltip_room_grp = new THREE.Group();
        tooltip_room_grp.quaternion.copy(room_boutique.children[0].quaternion);
        tooltip_room_grp.position.copy(room_boutique.children[0].position);
        scene.add(tooltip_room_grp);

        room_boutique.traverse(function (child) {
            if (child.type == 'Mesh') {
                var material_boutique = new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    side: 0,
                });

                if (child.name.includes('_ap_')) {
                    // boutique wall alpha contents
                    material_boutique.alphaMap = child.material.normalMap;
                    material_boutique.transparent = true;
                } else if (child.name == 'light') {
                    material_boutique.opacity = 1;
                    material_boutique.transparent = true;
                } else {
                    var copy_emissive = child.material.emissiveMap;
                    if (copy_emissive) {
                        copy_emissive.encoding = THREE.LinearEncoding;
                    }

                    if (copy_emissive) {
                        material_boutique.map = copy_emissive;
                    }
                }
                child.material = material_boutique;

                if (child.name.includes('Content_')) {
                    child._roomidx = 1;
                    var id_num = Number(child.name.slice(-2));
                    child._contentidx = id_num;

                    child.custom_x = null;
                    child.custom_y = 130;
                    child.custom_z = -40;
                    child.custom_roty = 0;
                    if (id_num == 1) {
                        child.custom_y = 150;
                    } else if (id_num == 2) {
                        child.custom_x = 125;
                    } else if (id_num == 3) {
                        child.custom_x = -80;
                        child.custom_y = 150;
                    } else if (id_num == 4) {
                        child.custom_x = -120;
                        child.custom_y = 160;
                    } else if (id_num == 5) {
                        child.custom_x = 115;
                        child.custom_y = 150;
                    } else if (id_num == 6) {
                        child.custom_y = 160;
                    } else if (id_num == 7) {
                        child.custom_x = 82;
                        child.custom_y = 90;
                    } else if (id_num == 8) {
                        child.custom_x = -110;
                        child.custom_y = 160;
                    }

                    createTooltips(tooltip_room_grp, child, 1, id_num);
                }
            }
        });

        /// CREATE INSTANCE BOUTIQUE STRIPLIGHTS

        const boustrip_rows = 22;
        const strip_perrow = 6;
        const boustrip_count = boustrip_rows * strip_perrow;
        const dummy = new THREE.Object3D();
        const boustrip_group = new THREE.Group();

        // var boustrip_Geometry = new THREE.BoxGeometry(1.5, 175, 1.5);
        var boustrip_Geometry = new THREE.BoxGeometry(2, 180, 2);
        var boustrip_Material = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            side: 0,
        });
        var boustrip_Mesh = new THREE.InstancedMesh(boustrip_Geometry, boustrip_Material, boustrip_count);
        boustrip_group.add(boustrip_Mesh);
        scene.add(boustrip_group);

        boustrip_group.quaternion.copy(room_boutique.children[0].quaternion);
        boustrip_group.position.copy(room_boutique.children[0].position);

        // set instanced positiions
        function setStripLightData(dummy, row_counter, iterationinrow, i) {
            var new_pos = new THREE.Vector3();

            new_pos.y = iterationinrow == 0 || iterationinrow == 2 ? 90 : 285.5;
            new_pos.z = -135 - row_counter * 200;

            if (iterationinrow == 0 || iterationinrow == 1) {
                new_pos.x = -186;
                dummy.rotation.z = 0;
            } else if (iterationinrow == 4) {
                dummy.rotation.z = Math.PI / 2;
                new_pos.x = -186 + 180 / 2;
                new_pos.y = 284 + 180 / 2;
            } else if (iterationinrow == 5) {
                dummy.rotation.z = Math.PI / 2;
                new_pos.x = 186 - 180 / 2;
                new_pos.y = 284 + 180 / 2;
            } else {
                dummy.rotation.z = 0;
                new_pos.x = 186;
            }

            dummy.position.copy(new_pos);

            dummy.updateMatrix();
            boustrip_Mesh.setMatrixAt(i, dummy.matrix);
        }

        var loop_counter = 0;
        var row_iteration_count = 0;

        for (let i = 0; i < boustrip_rows; i++) {
            row_counter = row_counter + i * strip_perrow;
            var row_counter = 0;
            for (let y = 0; y < strip_perrow; y++) {
                setStripLightData(dummy, row_iteration_count, row_counter, loop_counter);

                loop_counter++;
                row_counter++;
            }
            row_iteration_count++;
        }

        checkLoadedState();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

////////////////
////// LOAD GLTF -  PLAYER / SPORTS SCENE

var room_player;

modelLoader.load(
    // resource URL
    'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/models/compressed/player.glb',
    // './models/Player_0617.glb',
    // called when the resource is loaded
    function (gltf) {
        if (is_debug) {
            console.log('model loaded: player ', gltf);
        }

        room_player = gltf.scene;
        scene.add(room_player);

        params.jumpto_player();

        var tooltip_room_grp = new THREE.Group();
        tooltip_room_grp.quaternion.copy(room_player.children[0].quaternion);
        tooltip_room_grp.position.copy(room_player.children[0].position);
        scene.add(tooltip_room_grp);

        room_player.traverse(function (child) {
            if (child.type == 'Mesh') {
                var has_emissive = child.material.emissiveMap;
                var has_texture = child.material.map;
                var has_normal = child.material.normalMap;

                if (has_emissive) {
                    var copy_emissivemap = child.material.emissiveMap;
                    // copy_emissivemap.encoding = THREE.LinearEncoding;
                }
                if (has_texture) {
                    var copy_map = child.material.map;
                }
                if (has_normal) {
                    var copy_normalmap = child.material.normalMap;
                }

                var material_player = new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    // map: has_texture ? copy_map : null,
                    // alphaMap: has_texture ? copy_map : null,
                    map: has_emissive ? copy_emissivemap : null,

                    side: 0,
                });

                if (child.name.includes('_ap')) {
                    if (!child.name.includes('Text')) {
                        material_player.transparent = true;
                        material_player.alphaMap = copy_normalmap;
                        material_player.alphaTest = 0.5;
                        material_player.map = copy_emissivemap;
                        if (material_player.map) {
                            material_player.map.encoding = THREE.LinearEncoding;
                        }

                        if (child.name.includes('Content_')) {
                            var id_num = Number(child.name.slice(-2));
                            child._roomidx = 2;
                            child._contentidx = id_num;
                            // console.log('player', child.name, id_num, child._contentidx);

                            child.custom_x = null;
                            child.custom_y = null;
                            child.custom_z = -70;
                            child.custom_roty = 0;

                            if (id_num == 1 || id_num == 5 || id_num == 7) {
                                child.custom_x = -70;
                                child.custom_y = 320;
                            } else if (id_num == 2) {
                                // console.log('kk', child);
                                child.custom_y = 95;
                                child.custom_x = child.position.x + 115;
                            } else if (id_num == 3) {
                                child.custom_x = -90;
                                child.custom_y = 290;
                            } else if (id_num == 4) {
                                child.custom_y = 35;
                                child.custom_x = child.position.x + 120;
                            } else if (id_num == 6) {
                                child.custom_y = 120;
                                child.custom_x = child.position.x + 120;
                            } else if (id_num == 8) {
                                child.custom_y = 60;
                                child.custom_x = child.position.x + 140;
                            }

                            createTooltips(tooltip_room_grp, child, 2, id_num);
                        }
                        child.material = material_player;
                    }
                } else if (child.name == 'Floor') {
                    var material_runningtrack = new THREE.MeshBasicMaterial({
                        color: 0xffffff,
                        map: copy_emissivemap,
                        side: 0,
                    });
                    material_runningtrack.map.encoding = THREE.LinearEncoding;

                    child.material = material_runningtrack;
                } else {
                    child.material = material_player;
                }
            }
        });
        checkLoadedState();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

////////////////
////// LOAD GLTF -  BEAUTY SCENE

var room_beauty;

let confettiMesh;
let confettiGeometry;
let confettiMaterial;
const confetti_count = window.innerWidth > 768 ? 400 : 250;
const confetti_dummy = new THREE.Object3D();
var room_size = { w: 200, h: 200, depth: 3000 };

modelLoader.load(
    // resource URL
    // './models/compressed/beauty.glb',
    'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/models/Beauty_0616.glb',
    // called when the resource is loaded
    function (gltf) {
        if (is_debug) {
            console.log('model loaded: beauty ', gltf);
        }

        room_beauty = gltf.scene;
        scene.add(room_beauty);

        params.jumpto_beauty();

        var tooltip_room_grp = new THREE.Group();
        tooltip_room_grp.quaternion.copy(room_beauty.children[0].quaternion);
        tooltip_room_grp.position.copy(room_beauty.children[0].position);
        scene.add(tooltip_room_grp);

        room_beauty.traverse(function (child) {
            if (child.type == 'Mesh') {
                // console.log(child);
                var copy_emissivemap = child.material.emissiveMap;
                if (copy_emissivemap) {
                    copy_emissivemap.encoding = THREE.LinearEncoding;
                }
                var material_beauty = new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    map: copy_emissivemap,
                    // emissiveMap: copy_emissivemap,
                    side: 0,
                });

                if (child.name.includes('Content_')) {
                    var id_num = Number(child.name.slice(-2));
                    child._roomidx = 3;
                    child._contentidx = id_num;
                    // console.log('beauty', child.name, id_num, child._contentidx);

                    // controls y
                    child.custom_x = -50;
                    // controls x
                    child.custom_y = child.name.includes('_B_') ? -160 : 160;
                    child.custom_z = -30;
                    child.custom_roty = child.name.includes('_B_') ? Math.PI / -3 : Math.PI / 3;

                    // add tooltips
                    createTooltips(tooltip_room_grp, child, 3, id_num);
                }

                if (child.name.includes('Confetti')) {
                    child.visible = false;
                }

                child.material = material_beauty;
            }
        });

        // create instanceconfetti
        var max_spread = 10;
        var reduce_amt = 8;

        var cubemap_loader = new THREE.CubeTextureLoader();
        cubemap_loader.setPath('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/textures/environmentMaps/1/');

        var texture_format = '.jpg';
        var textureCube = cubemap_loader.load(['px' + texture_format, 'nx' + texture_format, 'py' + texture_format, 'ny' + texture_format, 'pz' + texture_format, 'nz' + texture_format]);

        confettiGeometry = new THREE.PlaneGeometry(10, 10, 1);
        confettiMaterial = new THREE.MeshPhysicalMaterial({
            color: 0xffffff,
            side: 2,
            envMap: textureCube,
            envMapIntensity: 3,
            transmission: 0.8,
            thickness: 1,
            roughness: 0.1,
            metalness: 0.1,
        });
        var confettiMeshGroup = new THREE.Group();
        confettiMesh = new THREE.InstancedMesh(confettiGeometry, confettiMaterial, confetti_count);
        confettiMesh.userData.phases = [];
        confettiMeshGroup.position.copy(room_beauty.children[0].position);
        confettiMeshGroup.quaternion.copy(room_beauty.children[0].quaternion);
        // console.log('!!!', confettiMesh);

        for (let i = 0; i < confetti_count; i++) {
            // const matrix = new THREE.Matrix4();
            // spiralMatrix(matrix, i);
            // petalMesh.setMatrixAt(i, matrix);
            setConfettiData(confetti_dummy, i);
        }

        confettiMeshGroup.add(confettiMesh);
        scene.add(confettiMeshGroup);
        // console.log('confettiMesh', confettiMesh);
        // console.log('confettiMeshGroup', confettiMeshGroup);
        confettiMesh.position.z = room_size.depth / -2;

        function setConfettiData(dummy, i) {
            var new_pos = new THREE.Vector3();

            // new_pos.x = Math.sin(i / 25) * (room_size.w - reduce_amt - (room_size.w - reduce_amt) / 3) + (Math.floor(Math.random() * max_spread) - max_spread / 2);
            // new_pos.y = Math.cos(i / 25) * (room_size.h - reduce_amt / 2 - (room_size.h - reduce_amt / 2) / 2) + (Math.floor(Math.random() * max_spread) - max_spread / 2);
            new_pos.x = randomNum(-room_size.w, room_size.w);
            new_pos.y = randomNum(-room_size.w, room_size.w);
            // new_pos.y = Math.cos(i / 25) * (room_size.h - reduce_amt / 2 - (room_size.h - reduce_amt / 2) / 2) + (Math.floor(Math.random() * max_spread) - max_spread / 2);

            // position.z = Math.random() * room_size.depth - room_size.depth / 2;
            new_pos.z = (i / confetti_count) * room_size.depth - room_size.depth / 2 + (Math.floor(Math.random() * max_spread) - max_spread / 5);

            // console.log(new_pos);

            confetti_dummy.position.copy(new_pos);

            confetti_dummy.rotation.x = Math.PI * Math.random() * 3;
            confetti_dummy.rotation.y = Math.PI * Math.random() * 3;
            confetti_dummy.rotation.z = Math.PI * Math.random() * 3;
            confetti_dummy.scale.x = confetti_dummy.scale.y = confetti_dummy.scale.z = Math.random() * 1;
            confetti_dummy.updateMatrix();
            confettiMesh.setMatrixAt(i, confetti_dummy.matrix);

            confettiMesh.userData.phases.push({
                phaseX: (Math.random() - 0.5) * Math.PI * 2,
                phaseY: (Math.random() - 0.5) * Math.PI * 2,
                phaseZ: (Math.random() - 0.5) * Math.PI * 2,
                phaseDepth: Math.random() * Math.PI * 2,
            });
        }

        checkLoadedState();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

////////////////
////// LOAD GLTF -  KIDS SCENE

var room_kids;

modelLoader.load(
    // resource URL
    'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/models/compressed/kids.glb',
    // './models/Kids_0617_02.glb',
    // called when the resource is loaded
    function (gltf) {
        if (is_debug) {
            console.log('model loaded: kids ', gltf);
        }

        room_kids = gltf.scene;
        scene.add(room_kids);

        params.jumpto_kids();

        var tooltip_room_grp = new THREE.Group();
        tooltip_room_grp.quaternion.copy(room_kids.children[0].quaternion);
        tooltip_room_grp.position.copy(room_kids.children[0].position);
        scene.add(tooltip_room_grp);

        room_kids.traverse(function (child) {
            if (child.type == 'Mesh') {
                if (child.name.includes('Object_')) {
                    if (child.name != 'Object_02' && child.name != 'Object_03') {
                        var tl_rotatekids_object = gsap.timeline({ repeat: -1, yoyo: false });
                        tl_rotatekids_object.to(child.rotation, { y: Math.PI * 2, duration: 2, ease: 'steps(10)' });
                    }
                    if (child.name == 'Object_02') {
                        // child.position.x += 20;
                        // child.position.z -= 5;
                    }
                    if (child.name == 'Object_03') {
                        // child.position.x -= 55;
                        // child.position.z += 60;
                    }
                } else {
                    if (child.material.emissiveMap) {
                        // if (child.name.includes('Content_')) {
                        child.material.emissiveMap.encoding = THREE.LinearEncoding;
                        // }
                    }

                    var material_kids = new THREE.MeshBasicMaterial({
                        color: child.material.color,
                        map: child.material.emissiveMap ? child.material.emissiveMap : null,
                        transparent: child.name == 'Logo_ap' ? true : false,
                        alphaMap: child.name == 'Logo_ap' ? child.material.normalMap : null,
                        // map: has_emissive ? copy_emissivemap : null,
                        side: 0,
                    });

                    child.material = material_kids;

                    if (child.name.includes('Content_') && !child.name.includes('Box')) {
                        var id_num = Number(child.name.slice(-2));
                        child._roomidx = 4;
                        child._contentidx = id_num;

                        child.custom_z = -60;
                        child.custom_roty = 0;
                        if (id_num == 1) {
                            child.custom_x = -50;
                            child.custom_y = 170;

                            child.custom_roty = 0;
                        } else if (id_num == 2) {
                            child.custom_x = 60;
                            child.custom_y = 170;

                            child.custom_roty = 0;
                        } else if (id_num == 3) {
                            child.custom_x = -130;
                            child.custom_y = 340;
                            child.custom_z = 0;
                        } else if (id_num == 4) {
                            child.custom_x = 50;
                            child.custom_y = 130;
                            child.custom_z = -50;
                        } else if (id_num == 5) {
                            child.custom_x = -60;
                            child.custom_y = 110;
                            child.custom_z = 0;
                        } else {
                            child.custom_x = null;
                            child.custom_y = null;
                        }

                        // add tooltips
                        createTooltips(tooltip_room_grp, child, 4, id_num);
                    }
                }
            }
        });

        checkLoadedState();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

////// LOAD GLTF -  GOLF SCENE

var room_golf;

var texture_tilesky_long = textureLoader.load('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/textures/golf_tex/Sky_01_edit.jpg');
texture_tilesky_long.wrapS = THREE.RepeatWrapping;
texture_tilesky_long.wrapT = THREE.RepeatWrapping;
texture_tilesky_long.repeat.set(1.8, 3.05);

modelLoader.load(
    // resource URL
    'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/models/compressed/golf.glb',
    // './models/golf_0603_02.glb',
    // called when the resource is loaded
    function (gltf) {
        if (is_debug) {
            console.log('model loaded: golf ', gltf);
        }

        room_golf = gltf.scene;

        scene.add(room_golf);

        params.jumpto_golf();

        var golfballs_3dobjects = [];
        var golf_floormesh;
        var golfframes_3dobjects = [];

        var golf_bridge;

        var tooltip_room_grp = new THREE.Group();
        tooltip_room_grp.quaternion.copy(room_golf.children[0].quaternion);
        tooltip_room_grp.position.copy(room_golf.children[0].position);
        scene.add(tooltip_room_grp);

        room_golf.traverse(function (child) {
            if (child.type == 'Mesh') {
                // console.log(child.name);

                if (child.name == 'Wall') {
                    var material_cloud_long = new THREE.MeshBasicMaterial({
                        color: 0xffffff,
                        map: texture_tilesky_long,
                        // side: 2,
                        side: 0,
                    });
                    child.material = material_cloud_long;
                } else if (child.name == 'Floor') {
                    golf_floormesh = child;

                    var texture_grass = textureLoader.load('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/textures/golf_tex/jandi_edit.jpg');
                    texture_grass.encoding = THREE.LinearEncoding;
                    texture_grass.wrapS = THREE.RepeatWrapping;
                    texture_grass.wrapT = THREE.RepeatWrapping;
                    texture_grass.repeat.set(4, 3);
                    // console.log(child.material);
                    var material_grass = new THREE.MeshStandardMaterial({
                        color: 0xffffff,
                        map: texture_grass,
                        envMap: hdrEquirect,
                        envMapIntensity: 0.4,
                        emissiveIntensity: 1,
                        side: 0,
                    });

                    child.material = material_grass;
                } else if (child.name.includes('Ball')) {
                    golfballs_3dobjects.push(child);
                } else if (child.name == 'Flag') {
                    var texture_flag = child.material.emissiveMap;

                    var material_golfflag = new THREE.MeshBasicMaterial({
                        color: 0xffffff,
                        map: texture_flag,
                        side: 0,
                    });

                    child.material = material_golfflag;
                } else if (child.name.includes('Content_')) {
                    var id_num = Number(child.name.slice(-2));

                    var texture_golfcontent = textureLoader.load('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/textures/golf_tex/' + child.name + '.jpg');
                    texture_golfcontent.flipY = false;
                    var material_golfcontent = new THREE.MeshBasicMaterial({
                        color: 0xffffff,
                        map: texture_golfcontent,
                        side: 0,
                    });
                    child.material = material_golfcontent;

                    child._roomidx = 5;
                    child._contentidx = id_num + (child.name.includes('_R_') ? 5 : 0);
                    // console.log('golf', child.name, id_num, child._contentidx);

                    child.custom_x = null;
                    child.custom_y = null;
                    child.custom_z = -50;
                    child.custom_roty = 0;

                    if (id_num == 1) {
                        child.custom_y = 130;
                    } else if (id_num == 2) {
                        child.custom_y = 130;
                    } else if (id_num == 3) {
                        child.custom_x = -130;
                    } else if (id_num == 4) {
                        child.custom_y = 180;
                    } else if (id_num == 5) {
                        child.custom_y = 150;
                    } else if (id_num == 6) {
                        child.custom_x = 150;
                        child.custom_y = 105;
                    } else if (id_num == 7) {
                        child.custom_x = -150;
                        child.custom_y = 125;
                    } else if (id_num == 8) {
                        child.custom_y = 185;
                    }

                    // add tooltips
                    createTooltips(tooltip_room_grp, child, 5, id_num);
                } else if (child.name.includes('Frame')) {
                    var frame_color = child.material.emissive;
                    var material_frame = new THREE.MeshBasicMaterial({
                        color: frame_color,
                        side: 0,
                        opacity: 1,
                        transparent: true,
                    });
                    child.material = material_frame;

                    // console.log('frame', child);

                    golfframes_3dobjects.push(child);
                } else if (child.name.includes('Bridge')) {
                    golf_bridge = child;
                }
            }
        });

        /// remove golf bridging (zfighting issue)
        golf_bridge.geometry.dispose();
        golf_bridge.material.dispose();
        golf_bridge.removeFromParent();

        ///// CREATE INSTANCE GOLF BALLS
        const instanced_golfball_count = 10;
        const dummy_golfball = new THREE.Object3D();
        const instancedgolfball_group = new THREE.Group();

        var normal_golfball = textureLoader.load('https://image.msscdn.net/musinsaUI/campaign/vrshowroom/textures/golf_tex/golfball.jpg');
        var instanced_golfball_Geometry = new THREE.SphereGeometry(8, 32, 32);
        var instanced_golfball_Material = new THREE.MeshStandardMaterial({
            // envMap: hdrEquirect,
            side: 0,
            color: 0xffffff,
            normalMap: normal_golfball,
            roughness: 0.8,
            emissive: 0xffffff,
            emissiveIntensity: 0.5,
            // transmission: 0.7,
            // thickness: 100,
        });

        var instanced_golfball_Mesh = new THREE.InstancedMesh(instanced_golfball_Geometry, instanced_golfball_Material, instanced_golfball_count);
        instancedgolfball_group.add(instanced_golfball_Mesh);
        room_golf.children[0].add(instancedgolfball_group);

        // set instanced positiions
        function setGolfBallData(dummy_golfball, i) {
            dummy_golfball.position.copy(golfballs_3dobjects[i].position);

            // console.log('golf ball', golfballs_3dobjects[i].position);
            dummy_golfball.updateMatrix();
            instanced_golfball_Mesh.setMatrixAt(i, dummy_golfball.matrix);
        }
        for (let i = 0; i < instanced_golfball_count; i++) {
            setGolfBallData(dummy_golfball, i);
        }

        // remove golfball from 3D
        for (let i = 0; i < golfballs_3dobjects.length; i++) {
            const one_golfball = golfballs_3dobjects[i];
            one_golfball.geometry.dispose();
            one_golfball.material.dispose();
            one_golfball.removeFromParent();
        }

        ///////

        /// CREATE INSTANCE GOLF FRAMES

        const dummy_frames = new THREE.Object3D();
        const frames_group = new THREE.Group();

        var frame_Geometry = new THREE.BoxGeometry(80, 120, 10);
        var frame_Material = new THREE.MeshBasicMaterial({
            color: new THREE.Color(0.8588235294117645, 0.9803921568627451, 0),
            side: 0,
        });
        var frame_Mesh = new THREE.InstancedMesh(frame_Geometry, frame_Material, golfframes_3dobjects.length);
        frames_group.add(frame_Mesh);
        scene.add(frames_group);

        frames_group.quaternion.copy(room_golf.children[0].quaternion);
        frames_group.position.copy(room_golf.children[0].position);

        // set instanced positiions
        function setGolfFrameData(dummy_frames, i) {
            //  var new_pos = new THREE.Vector3();

            dummy_frames.position.copy(golfframes_3dobjects[i].position);
            dummy_frames.quaternion.copy(golfframes_3dobjects[i].quaternion);

            if (golfframes_3dobjects[i].name.includes('02') || golfframes_3dobjects[i].name.includes('04') || golfframes_3dobjects[i].name.includes('06') || golfframes_3dobjects[i].name.includes('08')) {
                dummy_frames.rotation.y += Math.PI * 0.4592;
                dummy_frames.position.x += 0.5;
                //0.455 right
            } else {
                dummy_frames.position.x -= 0.5;
            }

            dummy_frames.updateMatrix();
            frame_Mesh.setMatrixAt(i, dummy_frames.matrix);
        }
        for (let i = 0; i < golfframes_3dobjects.length; i++) {
            setGolfFrameData(dummy_frames, i);
        }

        // remove original frame mesh from model
        for (let i = 0; i < golfframes_3dobjects.length; i++) {
            golfframes_3dobjects[i].geometry.dispose();
            golfframes_3dobjects[i].material.dispose();
            golfframes_3dobjects[i].removeFromParent();
        }

        checkLoadedState();
    },
    // called while loading is progressing
    function (xhr) {
        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    // called when loading has errors
    function (error) {
        console.log('An error happened', error);
    }
);

///////////////

// used to reset wheel when stop scrolling
let stopWheelTimer;
function onStopWheel() {
    params.target_scrolly = 0;
}

// wheeling in credit

var target_scrolly_credit = 0;
var current_scrolly_credit = 0;
var ease_scrolly_credit = 0.075;
var scrollspeed_credit = window.innerWidth > 570 ? 60000 : 100000;
var credit_svg = document.querySelector('.svg-container');
var credit_svg_y = 100;

let stopWheelTimer_credit;
function onStopWheel_credit() {
    target_scrolly_credit = 0;
    params.target_scrolly = 0;
}

function onWheel(e) {
    const normalized = normalizeWheel(event);

    if (!contentui_open && !contentui_open && !claimui_open && all_loaded) {
        params.target_scrolly = (normalized.pixelY / params.scrollspeed) * (params.speed_multiplier + (isSafariDesktop ? 1 : 0) + (os == 'windows' ? 3 : 0) - (isEdge ? 0.5 : 0));

        if (stopWheelTimer !== undefined) {
            clearTimeout(stopWheelTimer);
        }
        stopWheelTimer = setTimeout(() => onStopWheel(), 200);
    }

    if (credit_open) {
        // used to translate credit svg up or down on scroll
        target_scrolly_credit = (normalized.pixelY / scrollspeed_credit) * (params.speed_multiplier + (isSafariDesktop ? 0.5 : 0) + (os == 'windows' ? 3 : 0) - (isEdge ? 0 : 0));

        // if (credit_svg_y < 100) {
        /// when scrolling end credits, move camera towards M again
        params.target_scrolly = (normalized.pixelY / params.scrollspeed) * (params.speed_multiplier + (isSafariDesktop ? 0.5 : 0) + (os == 'windows' ? 3 : 0) - (isEdge ? 0 : 0));
        // }

        // if user scrolls forwards into start of static M frame
        /// jump to end frame of static m
        if (params.frametime > params.frametime_staticstart && params.frametime < params.frametime_staticstart + 0.5 && normalized.pixelY > 0) {
            console.log('JUMP TO END OF STATIC M FRAMETIME!');
            params.frametime = params.frametime_end2 - 0.01;
            updateSceneFromGUI();
        }
        // if user scrolls backwards into start of static M frame
        /// jump to end frame of static m
        if (params.frametime < params.frametime_end2 && params.frametime > params.frametime_end2 - 0.5 && normalized.pixelY < 0) {
            console.log('JUMP TO START OF STATIC M FRAMETIME!');
            params.frametime = params.frametime_staticstart - 0.01;
            updateSceneFromGUI();
        }

        if (stopWheelTimer_credit !== undefined) {
            clearTimeout(stopWheelTimer_credit);
        }
        stopWheelTimer_credit = setTimeout(() => onStopWheel_credit(), 200);
    }
}

var isDragging = false;

function onSwipe(e) {
    if (contentui_open) return;
    if (claimui_open) return;
    if (!all_loaded) return;
    if (!credit_open) {
        params.target_scrolly = (e.deltaY / -1800) * params.speed_multiplier;

        if (stopWheelTimer !== undefined) {
            clearTimeout(stopWheelTimer);
        }
        stopWheelTimer = setTimeout(() => onStopWheel(), 200);
    }

    if (credit_open) {
        // used to translate credit svg up or down on scroll
        target_scrolly_credit = (e.deltaY / -scrollspeed_credit) * 50;

        /// when scrolling end credits, move camera towards M again
        params.target_scrolly = e.deltaY / -1500;

        if (stopWheelTimer_credit !== undefined) {
            clearTimeout(stopWheelTimer_credit);
        }
        stopWheelTimer_credit = setTimeout(() => onStopWheel_credit(), 200);

        // if user is swiping forward into start of static M frame
        /// jump to end frame of static m

        if (params.frametime > params.frametime_staticstart && params.frametime < params.frametime_staticstart + 0.5 && e.deltaY < 0) {
            console.log('JUMP TO END OF STATIC M FRAMETIME!');
            params.frametime = params.frametime_end2 - 0.01;
            updateSceneFromGUI();
        }
        // if user swipes backwards into start of static M frame
        /// jump to end frame of static m
        if (params.frametime < params.frametime_end2 && params.frametime > params.frametime_end2 - 0.5 && e.deltaY > 0) {
            console.log('JUMP TO START OF STATIC M FRAMETIME!');
            params.frametime = params.frametime_staticstart - 0.01;
            updateSceneFromGUI();
        }
    }

    isDragging = true;
}

// for desktop
window.onwheel = onWheel;

/////////////

// for touch devices
Observer.create({
    target: window, // can be any element (selector text is fine)
    type: 'touch', // comma-delimited list of what to listen for ("wheel,touch,scroll,pointer")
    dragMinimum: 10,
    onUp: (ev) => {
        onSwipe(ev);
    },
    onDown: (ev) => {
        onSwipe(ev);
    },
    onRelease: (ev) => {
        // console.log('released');
        isDragging = false;
    },
});

////

function onPointerMove(event) {
    pointer.x = params.mouse.target_x = (event.clientX / window.innerWidth) * 2 - 1;
    pointer.y = params.mouse.target_y = -(event.clientY / window.innerHeight) * 2 + 1;

    // console.log(pointer.x, pointer.y);
}
function onPointerClick(event) {
    if (contentui_open) return;
    if (claimui_open) return;
    if (!all_loaded) return;
    if (event.target.tagName != 'CANVAS') return;
    if (window.innerWidth < 1024) {
        pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
        pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;

        findIntersections();
    }

    // console.log('pointerclick', pointer.x, pointer.y);
    if (INTERSECTED && !isDragging) {
        if (INTERSECTED.name.includes('content') || INTERSECTED.name.includes('Content') || INTERSECTED.name.includes('CONTENT') || INTERSECTED.name.includes('Clickable')) {
            if (INTERSECTED.name.includes('Box')) return;
            openContentUI(INTERSECTED._roomidx, INTERSECTED._contentidx);
        }
    }
}

window.addEventListener('pointermove', onPointerMove);
window.addEventListener('pointerup', onPointerClick);

/////

function findIntersections() {
    // find intersections
    if (isDragging) return;

    // console.log(isDragging);

    raycaster.setFromCamera(pointer, camera);

    const intersects = raycaster.intersectObjects(scene.children);

    if (intersects.length > 0) {
        if (INTERSECTED != intersects[0].object) {
            INTERSECTED = intersects[0].object;

            if (!INTERSECTED.name.includes('Outside')) {
                // console.log('intersect', INTERSECTED);
            }

            if (INTERSECTED.name.includes('content') || INTERSECTED.name.includes('Content') || INTERSECTED.name.includes('CONTENT') || INTERSECTED.name.includes('Clickable')) {
                if (!contentui_open && !claimui_open && all_loaded) {
                    document.body.style.cursor = 'pointer';
                }
            } else {
                document.body.style.cursor = 'default';
            }

            // INTERSECTED.currentHex = INTERSECTED.material.emissive.getHex();
            // INTERSECTED.material.emissive.setHex( 0xff0000 );
        }
    } else {
        if (INTERSECTED) {
            // INTERSECTED.material.emissive.setHex(INTERSECTED.currentHex);
        }

        INTERSECTED = null;
    }
}

/////
var clock = new THREE.Clock();
let mat4 = new THREE.Matrix4();

/// TICK
function render() {
    // TO ADD -
    renderer.render(scene, camera);

    params.current_scrolly += (params.target_scrolly - params.current_scrolly) * params.ease_scrolly;

    if (active_room == 5) {
        // texture_tilesky_long.offset.x += 0.0001;
        // texture_tilesky_long.offset.y += 0.0006;
        // texture_tilesky_long.offset.x += 0.00013;
        // texture_tilesky_long.offset.y += 0.00006;
    }

    // console.log(params.current_scrolly);
    // console.log(mixer);
    const deltaTime = clock.getDelta();

    if (mixer) {
        if (!params.autoScroll) {
            mixer.update(params.current_scrolly);
        } else {
            mixer.update(deltaTime / 4);
        }
        if (add_gui) {
            params.frametime = mixer.time;
            controller_timeframe.updateDisplay();
        }

        const new_pos = new THREE.Vector3();
        camera_position = camera.getWorldPosition(new_pos);
        // console.log(camera_position);

        // }
    }

    if (is_debug) {
        if (stats) {
            stats.update();
        }
    }

    if (controls) {
        controls.update();
    }

    params.mouse.current_x += (params.mouse.target_x - params.mouse.current_x) * params.mouse.ease;
    params.mouse.current_y += (params.mouse.target_y - params.mouse.current_y) * params.mouse.ease;

    // camera.rotation.z = params.mouse.current_y / 50;
    // camera.rotation.y = params.mouse.current_x / -1000;
    // console.log(camera.rotation.y)

    // raycast
    findIntersections();

    var active_room_touse;

    if (params.frametime >= /*params.frametime_steady*/ -0.7 && params.frametime < params.frametime_boutique) {
        // console.log('IN STEADY');
        active_room_touse = 0;
    } else if (params.frametime >= params.frametime_boutique && params.frametime < params.frametime_player) {
        // console.log('IN BOUTIQUE');
        active_room_touse = 1;
    } else if (params.frametime >= params.frametime_player && params.frametime < params.frametime_beauty) {
        // console.log('IN PLAYER');
        active_room_touse = 2;
    } else if (params.frametime >= params.frametime_beauty && params.frametime < params.frametime_kids) {
        // console.log('IN BEAUTY');
        active_room_touse = 3;
    } else if (params.frametime >= params.frametime_kids && params.frametime < params.frametime_golf) {
        // console.log('IN KIDS');
        active_room_touse = 4;
    } else if (params.frametime >= params.frametime_golf && params.frametime < params.frametime_outside) {
        // console.log('IN GOLF');
        active_room_touse = 5;
    } else if (params.frametime >= params.frametime_outside && params.frametime < params.frametime_end) {
        active_room_touse = 6;
        // console.log('OUTSIDE GOLF');
    } else if (params.frametime >= params.frametime_end && params.frametime < 41) {
        active_room_touse = 7;
        // console.log('CREDITS');
    } else if (params.frametime >= 41 && params.frametime < (window.innerWidth > 570 ? 44.5 : 41.5)) {
        active_room_touse = 8;
        // console.log('CREDITS ENDED IN LIMBO');
    } else {
        // console.log('AFTER END');
        active_room_touse = 9;
    }

    if (active_room_touse < 6 && active_room_touse != active_room) {
        // console.log(active_room_touse, active_room);
        updateIntroUI(active_room_touse);
    }

    // console.log(active_room_touse, params.frametime);
    // console.log(active_room_touse == 7, active_room_touse != active_room, all_loaded);
    // console.log(active_room_touse, active_room);
    if (active_room_touse == 7 && active_room_touse != active_room && all_loaded) {
        console.log('show credit c1a');
        if (params.frametime < 35) {
            enterCredits(active_room_touse, 'head');
        }
    }
    if (active_room_touse == 8 && active_room_touse != active_room && all_loaded && !credit_open) {
        console.log('show credit c1b');
        if (params.frametime > 41) {
            enterCredits(active_room_touse, 'tail');
        }
    }

    if (params.frametime >= 46.66666793823242) {
        params.jumpto_steady();
    }

    if (active_room_touse == 6) {
        // params.speed_multiplier = 2;
    } else if (active_room_touse == 8) {
        // params.speed_multiplier = 3.5;
    } else {
        // params.speed_multiplier = 1;
    }

    //// CREDIT SCROLL
    if (credit_open) {
        current_scrolly_credit += (target_scrolly_credit - current_scrolly_credit) * ease_scrolly_credit;

        credit_svg_y -= current_scrolly_credit * 100;

        credit_svg.style.transform = `translate(-50%, ${credit_svg_y}vh)`;
        // console.log(current_scrolly_credit, credit_svg_y);

        if (window.innerWidth > 570) {
            if (credit_svg_y < -140) {
                endCredits('tail', credit_svg_y);
            }
            if (credit_svg_y > 100) {
                endCredits('head', credit_svg_y);
            }
        } else {
            if (credit_svg_y < -440) {
                endCredits('tail', credit_svg_y);
            }
            if (credit_svg_y > 100) {
                endCredits('head', credit_svg_y);
            }
        }
    }

    if (active_room_touse != active_room && all_loaded) {
        active_room = active_room_touse;
        if (is_debug) {
            console.log('updaate active room', active_room);
        }
    }

    // console.log(active_room);

    // for (let i = 0; i < tooltip_arr.length; i++) {
    //     const single_t = tooltip_arr[i];
    //     single_t.lookAt(camera.position);
    // }

    requestAnimationFrame(render);
}

var timeout_introui;
function updateIntroUI(newroomidx) {
    if (!all_loaded) return;
    //

    // clearTimeout(timeout_introui);
    gsap.killTweensOf('.roomintro-ui');
    gsap.killTweensOf('.roomintro-ui .grp-1');
    gsap.killTweensOf('.roomintro-ui .grp-2');
    gsap.to('.roomintro-ui', {
        opacity: 0,
        duration: 0.2,
        ease: 'power1.inOut',
        onComplete: () => {
            gsap.set('.roomintro-ui .grp-1', { clearProps: 'all' });
            gsap.set('.roomintro-ui .grp-2', { clearProps: 'all' });
            document.querySelector('.roomintro-ui .room-logo').setAttribute('src', 'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/contents/' + data[newroomidx].roomlogo);
            document.querySelector('.roomintro-ui .room-logo').setAttribute('class', 'room-logo rl-' + data[newroomidx].roomname.replace(' ', '').toLowerCase());

            document.querySelector('.roomintro-ui .intro-text1').innerHTML = data[newroomidx].introtext;
            document.querySelector('.roomintro-ui .intro-text2').innerHTML = data[newroomidx].introtext2;
        },
    });

    // document.querySelector('.roomintro-ui span').innerHTML = data[newroomidx].introtext;

    if (is_debug) {
        console.log('changed room', active_room);
    }

    // var _start_delay = first_show ? 2.3 : 0;
    var _start_delay = window.innerWidth > 570 ? 0 : 2.2;
    var _dur = 0.5;
    var _delay = 2.7 + _start_delay;
    gsap.to('.roomintro-ui', { delay: 0.2 + _start_delay, opacity: 1, duration: 0.4, ease: 'power1.inOut' });
    gsap.to('.roomintro-ui .grp-1', { delay: _delay, opacity: 0, duration: _dur, ease: 'power1.inOut' });
    gsap.to('.roomintro-ui .grp-1', { delay: _delay, y: '-100%', duration: _dur, ease: 'power1.inOut' });
    gsap.fromTo('.roomintro-ui .grp-2', { opacity: 0 }, { delay: _delay + 0.35, opacity: 1, duration: _dur, ease: 'power1.inOut' });
    gsap.fromTo(
        '.roomintro-ui .grp-2',
        { y: '100%' },
        {
            delay: _delay + 0.35,
            y: 0,
            duration: _dur,
            ease: 'power2.Out',
            onComplete: () => {
                gsap.to('.roomintro-ui', { opacity: 0, delay: 2, duration: 0.4, ease: 'power1.inOut' });

                if (claim_progress != claim_total) {
                    gsap.to('.logo-basic', { opacity: 1, duration: 0.3, delay: 0.2, ease: 'power1.inOut' });
                }
            },
        }
    );

    // if (newroomidx == 5) {
    //     console.log('in golf');
    //     params.speed_multiplier = 0.1;
    // } else {
    //     params.speed_multiplier = 1;
    // }
    playRoomsBlipTL(newroomidx);

    first_show = false;
}

function playRoomsBlipTL(roomidx) {
    // pause all blips anims first
    for (let i = 0; i < data.length; i++) {
        for (let y = 0; y < data[i].tlblip_arr.length; y++) {
            const tl_topause = data[i].tlblip_arr[y];
            tl_topause.pause();
        }
    }

    // then play tl blips of only currently active room
    for (let z = 0; z < data[roomidx].tlblip_arr.length; z++) {
        const tl_toplay = data[roomidx].tlblip_arr[z];
        tl_toplay.play();
    }
}

function enterCredits(newroomidx, via) {
    if (is_debug) {
        console.log('SHOW CREDITS', via, params.frametime);
    }

    // reset credit svg position
    if (via == 'head') {
        // if enter credit  via head
        current_scrolly_credit = 0;
        target_scrolly_credit = 0;
        credit_svg_y = 100;
        credit_svg.style.transform = `translate(-50%, ${credit_svg_y}vh)`;
    } else if (via == 'tail') {
        // if enter credit via tail
        current_scrolly_credit = 0;
        target_scrolly_credit = 0;
        credit_svg_y = window.innerWidth > 570 ? -139 : -439;
        credit_svg.style.transform = `translate(-50%, ${credit_svg_y}vh)`;
    }

    // reset scroll values ease to 0
    // params.current_scrolly = 0;
    // params.target_scrolly = 0;
    credit_open = true;

    // params.frametime = params.frametime_end2 - 0.01;
    // updateSceneFromGUI();

    document.body.classList.add('show-credits');
}

function endCredits(via, val) {
    if (is_debug) {
        console.log('CREDITS END', via, val);
    }

    credit_open = false;
    document.body.classList.remove('show-credits');

    /// reset credits
    // if (via == 'head') {
    //     params.frametime = params.frametime_end - 0.001;
    //     updateSceneFromGUI();
    // }
}

function onResize() {
    console.log('resize window');
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
}
window.onresize = onResize;

render();

//////

function checkLoadedState() {
    loaded_models++;

    // gsap.killTweensOf('#load-progress');
    // gsap.to('#load-progress', { width: (loaded_models / total_models) * 100 + '%', duration: 0.2 });

    if (loaded_models == total_models) {
        if (is_debug) {
            console.log('all loaded');
        }
        params.frametime = 38.062;
        updateSceneFromGUI();

        setTimeout(() => {
            // SET START POSITION
            // params.frametime = 0;

            // params.frametime = window.innerWidth > 800 ? -0.17211084666666668 : -0.2540411176188962;
            // params.frametime = 33;
            // params.frametime = params.frametime_golf;
            // updateSceneFromGUI();
            document.querySelector('.panel-content').scrollTop = 0;

            gsap.to('.loading-meter', { opacity: 0, duration: 0.4, ease: 'power1.inOut' });
            gsap.to('.footer', {
                y: '-=110px',
                duration: 0.8,
                delay: 0.3,
                ease: 'power2.inOut',
            });
            gsap.to('.footer .button', { opacity: 1, pointerEvents: 'auto', delay: 0.75, duration: 0.6, ease: 'power1.inOut' });
        }, 2000);

        // console.log(all_contents_arr);
    }
}

///// hide loader
function hideLoader() {
    params.frametime = window.innerWidth > 800 ? -0.0896 : -0.2540411176188962;
    updateSceneFromGUI();

    bgm.volume = 0.5;
    bgm.play();

    playSoundEffect(sound_tap);

    setClickedCloseButton(document.querySelector('.loading-screen .button'));
    gsap.set('.loading-screen', { pointerEvents: 'none' });
    gsap.to('.loading-screen', {
        opacity: 0,
        display: 'none',
        delay: 0.25,
        onComplete: () => {
            all_loaded = true;
            updateIntroUI(0);
            playRoomsBlipTL(0);

            gsap.to('.ui-swipe', {
                opacity: 0,
                duration: 0.4,
                delay: 2,
                onComplete: () => {
                    document.querySelector('.ui-swipe').classList.add('no-animate');

                    populateCredits();
                },
            });
        },
    });
}

document.querySelector('.footer .button').onclick = hideLoader;

//////////////

function createTooltips(tooltip_room_grp, child, roomid, id_num) {
    // return;
    if (roomid == 1) {
        if (child.name.includes('ap')) return;
    } else if (roomid == 3) {
        if (child.name.includes('Table') || child.name.includes('A_01') || child.name.includes('A_02') || child.name.includes('A_03') || child.name.includes('B_04') || child.name.includes('B_05')) {
            return;
        }
    }

    var measure = new THREE.Vector3();
    var measure_box = child.geometry.boundingBox.getSize(measure);

    // add tooltips
    var single_tooltip_grp = new THREE.Group();

    var tooltip_mesh1 = new THREE.Mesh(tooltip_geometry, tooltip_material);
    tooltip_mesh1.name = 'Clickable';
    tooltip_mesh1._roomidx = roomid;
    tooltip_mesh1._contentidx = id_num;
    tooltip_mesh1.position.copy(child.position);
    // tooltip_mesh.quaternion.copy(child.quaternion);
    tooltip_mesh1.position.x += (measure_box.x / 2 - 15) * (child.position.x < 0 ? 0.7 : -0.7);
    // console.log()
    tooltip_mesh1.position.z += 80 + child.custom_z;
    tooltip_mesh1.position.y += measure_box.y / 2 - 20;
    tooltip_mesh1.scale.set(0.7, 0.7, 0.7);
    if (roomid == 3) {
        tooltip_mesh1.rotation.x = child.custom_roty;
    }
    var tooltip_mesh2 = tooltip_mesh1.clone();
    tooltip_mesh2._roomidx = roomid;
    tooltip_mesh2._contentidx = id_num;
    tooltip_mesh2.material = tooltip_material2;
    tooltip_mesh2.material.alphaTest = 0.01;
    tooltip_mesh2.scale.set(1, 1, 1);
    tooltip_mesh2.position.z -= 0.05;
    if (roomid == 3) {
        tooltip_mesh2.rotation.x = child.custom_roty;
    }

    if (child.custom_x) {
        tooltip_mesh1.position.x = tooltip_mesh2.position.x = child.custom_x;
    }
    if (child.custom_y) {
        tooltip_mesh1.position.y = tooltip_mesh2.position.y = child.custom_y;
    }

    single_tooltip_grp.add(tooltip_mesh1);
    tooltip_arr.push(tooltip_mesh1);
    single_tooltip_grp.add(tooltip_mesh2);
    tooltip_arr.push(tooltip_mesh2);
    tooltip_room_grp.add(single_tooltip_grp);

    var tl_blip = gsap.timeline({ repeat: -1, paused: true });
    tl_blip.addLabel('start');
    tl_blip.fromTo(tooltip_mesh2.material, { opacity: 1 }, { opacity: 0, duration: 1, ease: 'power1.inOut' }, 'start');
    tl_blip.fromTo(tooltip_mesh2.scale, { x: 0.7, y: 0.7, z: 0.7 }, { x: 1.1, y: 1.1, z: 1.1, duration: 1, ease: 'power2.Out' }, 'start');
    data[roomid].tlblip_arr.push(tl_blip);
}

//////////////

//////////////

function openContentUI(roomidx, contentidx) {
    if (is_debug) {
        document.querySelector('.content-title label').innerHTML = INTERSECTED.name;
    }
    playSoundEffect(sound_tap);
    populateContentUI(roomidx, contentidx);

    var base_delay = 0.1;

    gsap.killTweensOf('.content-ui .panel');
    gsap.killTweensOf('.content-ui .content-title');
    gsap.killTweensOf('.content-ui .brand-text-row');
    gsap.killTweensOf('.content-ui .intro-text-row');
    gsap.killTweensOf('.content-ui .hashtag-text');
    gsap.killTweensOf('.content-ui .button');
    gsap.killTweensOf('.content-ui .image-wrap');
    gsap.killTweensOf('.content-ui .ee-wrap');

    gsap.to('.content-ui', { opacity: 1, display: 'flex', duration: 0.5, delay: 0.1 });
    gsap.fromTo('.content-ui .panel', { x: '-50%', y: 50 }, { x: '-50%', y: 0, duration: 0.5, ease: 'pow2.Out', delay: 0.1 });
    gsap.fromTo('.content-ui .content-title', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.2 + base_delay });
    gsap.fromTo('.content-ui .brand-text-row', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.4 + base_delay });
    gsap.fromTo('.content-ui .intro-text-row', { opacity: 0 }, { opacity: 1, duration: 0.4, ease: 'pow1.inOut', delay: 0.4 + base_delay });
    gsap.fromTo('.content-ui .intro-text-row', { y: window.innerWidth > 768 ? 10 : 10 }, { y: 0, duration: 0.4, ease: 'pow2.Out', delay: 0.4 + base_delay });
    gsap.fromTo('.content-ui .hashtag-text', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.45 + base_delay });
    gsap.fromTo('.content-ui .button', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.6 + base_delay });
    gsap.fromTo('.content-ui .image-wrap', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: (window.innerWidth > 570 ? 0.7 : 0.6) + base_delay });
    gsap.fromTo('.content-ui .ee-wrap', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.7 + base_delay });

    // reset content scroll position
    setTimeout(() => {
        document.querySelector('.panel-content').scrollTop = 0;
    }, 130);

    contentui_open = true;
}
function closeContentUI(viaclaim) {
    gsap.to('.content-ui', { opacity: 0, display: 'none' });
    contentui_open = false;
    if (!viaclaim) {
        playSoundEffect(sound_tap);
    }
}
function setClickedCloseButton(ele) {
    ele.classList.add('clicked');
    setTimeout(() => {
        ele.classList.remove('clicked');
    }, 600);
}
function populateContentUI(roomidx, contentidx) {
    if (is_debug) {
        console.log('populate', roomidx, contentidx);
    }
    var data_to_use = data[roomidx].contents[contentidx - 1];
    var brandslug = data_to_use.brandname.replace(/\s/g, '').toLowerCase();

    document.querySelector('.panel .brand-text').innerHTML = data_to_use.brandnamekr;
    document.querySelector('.panel .intro-text').innerHTML = window.innerWidth > 570 ? data_to_use.intro : data_to_use.intromobile;
    document.querySelector('.panel .hashtag-text').innerHTML = data_to_use.hashtag;
    document.querySelector('.panel .brand-logo').setAttribute('src', 'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/contents/panel/logos/img_logo_' + brandslug + '.' + data_to_use.logoformat);
    // document.querySelector('.panel .brand-logo').setAttribute('src', 'contents/panel/logos/img_logo_' + brandslug + '.' + data_to_use.logoformat);
    document.querySelector('.panel .image-wrap').innerHTML = '';
    document.querySelector('.panel .button a').setAttribute('href', data_to_use.brandshopurl);

    // console.log(document.querySelector('.panel .button').getAttribute('href'));/

    for (let i = 0; i < data_to_use.imagecount; i++) {
        document.querySelector('.panel .image-wrap').innerHTML += `<img src="https://image.msscdn.net/musinsaUI/campaign/vrshowroom/contents/panel/images/${brandslug}/img_brand_0${i + 1}.jpg" alt="${data_to_use.brandname}"> `;
        // document.querySelector('.panel .image-wrap').innerHTML += `<img src="contents/panel/images/${brandslug}/img_brand_0${i + 1}.jpg" alt="${data_to_use.brandname}"> `;
    }

    populateClaim(data_to_use);
}

document.querySelector('.content-ui .close-content').onclick = (e) => {
    closeContentUI();

    setClickedCloseButton(document.querySelector('.content-ui .close-content'));
};

function updateSceneFromGUI(val) {
    if (add_gui && !controls) {
        if (mixer) {
            mixer.setTime(params.frametime);
        }
        // console.log(params);
        controller_timeframe.updateDisplay();

        camera.fov = params.cameraFOV;
        camera.updateProjectionMatrix();

        has_applied = params.alreadyApply;
    }
}

///// KEYBOARD SHORTCUTS

document.addEventListener('keydown', function (e) {
    if (is_debug) {
        console.log(e.keyCode);
    }
    if (e.keyCode == 27) {
        // ESCAPE KEY
        closeContentUI();
        closeClaimUI();
    } else if (e.keyCode == 49) {
        if (!is_debug) return;
        params.jumpto_steady();
    } else if (e.keyCode == 50) {
        if (!is_debug) return;
        params.jumpto_boutique();
    } else if (e.keyCode == 51) {
        if (!is_debug) return;
        params.jumpto_player();
    } else if (e.keyCode == 52) {
        if (!is_debug) return;
        params.jumpto_beauty();
    } else if (e.keyCode == 53) {
        if (!is_debug) return;
        params.jumpto_kids();
    } else if (e.keyCode == 54) {
        if (!is_debug) return;
        params.jumpto_golf();
    } else if (e.keyCode == 192) {
        if (!is_debug) return;
        params.frametime = 29.187124692720214;
        // params.frametime = 33.52689201326069;
        updateSceneFromGUI();
    }
});

function randomNum(min, max) {
    return Math.floor(min + Math.random() * (max - min + 1));
}

var randomized_count = 0;

function setUpClaim() {
    //randomize slots

    while (randomized_count < 6) {
        randomizeSlot();
    }
}
function randomizeSlot() {
    // var random_room = randomNum(0, 5);
    var random_room = randomized_count;
    var random_content = randomNum(0, data[random_room].contents.length - 1);
    var random_data = data[random_room].contents[random_content];

    if (data[random_room].hasee > -1) return;

    data[random_room].hasee = randomized_count;

    random_data.ee.hasee = randomized_count;

    randomized_count++;

    // console.log('randomslots', random_room, random_content, random_data);

    document.querySelector('.token-location').innerHTML += `<li>${data[random_room].roomname} - ${random_data.brandname}</li>`;
}

var newTokenImgGrp = document.createElement('div');
newTokenImgGrp.setAttribute('class', 'token-img-grp');
newTokenImgGrp.innerHTML = `<img class='token-m' src='https://image.msscdn.net/musinsaUI/campaign/vrshowroom/contents/token-m.png' alt='token'/><div class='ee-tooltip'>HELLO</div>`;
var infiniteTextImg = document.createElement('img');
infiniteTextImg.setAttribute('class', 'text-infinite');
infiniteTextImg.src = 'https://image.msscdn.net/musinsaUI/campaign/vrshowroom/contents/infinite-text.svg';

function populateClaim(slot) {
    document.querySelector('.ee-wrap .inner').innerHTML = '';
    if (slot.ee.hasee > -1) {
        // var newEEimg = document.createElement('img');
        // newEEimg.src = './ui/token-' + (slot.ee.hasee + 1) + '.png';

        document.querySelector('.ee-wrap .inner').appendChild(infiniteTextImg);
        document.querySelector('.ee-wrap .inner').appendChild(newTokenImgGrp);
        gsap.set('.ee-wrap', { display: 'flex' });

        if (!slot.ee.claimed) {
            // FIRST TOKEN ENCOUNTER
            document.querySelector('.ee-wrap .ee-tooltip').innerHTML = '토큰을 터치해주세요!';
            document.querySelector('.ee-wrap').classList.remove('claimed-state');
            newTokenImgGrp.onclick = () => {
                handleClaim(slot);
                closeContentUI(true);
            };
        } else {
            // ALREADY CLAIMED
            document.querySelector('.ee-wrap .ee-tooltip').innerHTML = '이미 찾은 인피니트 M 입니다!';
            document.querySelector('.ee-wrap').classList.add('claimed-state');
        }
    } else {
        gsap.set('.ee-wrap', { display: 'none' });
        // document.querySelector('.ee-wrap .ee-message').innerHTML = 'NO EASTER EGG';
    }
}

function handleClaim(slot) {
    if (!contentui_open) return;

    claim_progress++;
    playSoundEffect(sound_token);

    // append new token to claim ui
    setTimeout(() => {
        document.querySelector('.single-progress-marker-' + (claim_progress - 1)).classList.add('completed');
        document.querySelector('.single-progress-marker-' + (claim_progress - 1)).classList.add('temporary-style');

        setTimeout(() => {
            document.querySelector('.single-progress-marker-' + (claim_progress - 1)).classList.remove('temporary-style');
        }, 2000);
    }, 300);
    slot.ee.claimed = true;

    if (claim_progress == claim_total) {
        gsap.killTweensOf('.logo-basic');
        gsap.killTweensOf('.logo-success');
        gsap.killTweensOf('.logo-click');
        gsap.killTweensOf('.logo-touch');

        gsap.to('.logo-basic', { opacity: 0, duration: 0.6, ease: 'power1.inOut' });
        gsap.to('.logo-success', {
            opacity: 1,
            duration: 0.6,
            delay: 0.4,
            ease: 'power1.inOut',
            onComplete: () => {
                gsap.killTweensOf('.logo-basic');
                gsap.killTweensOf('.logo-success');
                gsap.killTweensOf('.logo-click');
                gsap.killTweensOf('.logo-touch');

                console.log('oc fade out success, in handle claim ');

                document.querySelector('.claim-ui .content-wrap').scrollTop = 0;
                setTimeout(() => {
                    if (!claimui_open) {
                        gsap.to('.logo-success', { opacity: 0, duration: 0.3, ease: 'power1.inOut' });
                        gsap.to('.logo-basic', { opacity: 0, duration: 0.3, ease: 'power1.inOut' });

                        gsap.to(window.innerWidth > 768 ? '.logo-click' : '.logo-touch', { opacity: 1, duration: 0.3, delay: 0.2, ease: 'power1.inOut' });
                    }
                }, 1200);
            },
        });
        document.body.classList.add('all-claimed');
    }
}

setUpClaim();

/////

function openClaimUI(viaclaiming) {
    playSoundEffect(sound_tap);
    closeContentUI();

    // if openeing claimui via claiming token
    // hide newly added token first to animate after ui fades in
    // if (viaclaiming) {
    // gsap.set('.single-slot  img', { opacity: 0, scale: 0.5 });
    // }
    setTimeout(() => {
        document.querySelector('.claim-ui .content-wrap').scrollTop = 0;
    }, 100);

    gsap.killTweensOf('.claim-ui .panel');
    gsap.killTweensOf('.claim-ui .congrats');
    gsap.killTweensOf('.claim-ui .congrats-text');
    gsap.killTweensOf('.claim-ui .event-banner');
    gsap.killTweensOf('.claim-ui .single-m-grid');
    gsap.set('.claim-ui .single-m-grid', { clearProps: 'all' });
    gsap.killTweensOf('.claim-ui .glow-m');
    gsap.killTweensOf('.claim-ui .final-m');
    gsap.killTweensOf('.logo-click');
    gsap.killTweensOf('.logo-touch');

    // gsap.to('.content-ui', { opacity: 1, display: 'flex', duration: 0.4, delay: 0.1 });
    // gsap.fromTo('.content-ui .panel', { x: '-50%', y: 50 }, { x: '-50%', y: 0, duration: 0.4, ease: 'pow2.Out', delay: 0.1 });
    // gsap.fromTo('.content-ui .content-title', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.2 + base_delay });
    // gsap.fromTo('.content-ui .brand-text-row', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.4 + base_delay });
    // gsap.fromTo('.content-ui .intro-text-row', { opacity: 0 }, { opacity: 1, duration: 0.4, ease: 'pow1.inOut', delay: 0.4 + base_delay });
    // gsap.fromTo('.content-ui .intro-text-row', { y: window.innerWidth > 768 ? 10 : 10 }, { y: 0, duration: 0.4, ease: 'pow2.Out', delay: 0.4 + base_delay });
    // gsap.fromTo('.content-ui .hashtag-text', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.45 + base_delay });
    // gsap.fromTo('.content-ui .button', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.6 + base_delay });
    // gsap.fromTo('.content-ui .image-wrap', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.7 + base_delay });
    // gsap.fromTo('.content-ui .ee-wrap', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: 0.7 + base_delay });

    var base_delay = 0.1;
    gsap.to('.claim-ui', { opacity: 1, display: 'flex', delay: 0.1 });

    gsap.fromTo('.claim-ui .panel', { x: '-50%', y: 50 }, { x: '-50%', y: 0, duration: 0.5, ease: 'pow2.Out', delay: 0.1 });
    gsap.fromTo('.claim-ui .congrats', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: base_delay + 0.2 });
    gsap.fromTo('.claim-ui .congrats-text', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: base_delay + 0.4 });
    gsap.fromTo('.claim-ui .event-banner', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'pow1.inOut', delay: base_delay + 0.7 });
    gsap.fromTo('.claim-ui .single-m-grid', { opacity: 0 }, { opacity: 1, duration: 0.4, stagger: 0.15, ease: 'pow1.inOut', delay: base_delay + 0.3 });

    gsap.to(window.innerWidth > 768 ? '.logo-click' : '.logo-touch', { opacity: 0, duration: 0.3, delay: 0.2, ease: 'power1.inOut' });
    gsap.to('.logo-basic', { opacity: 0, duration: 0.3, delay: 0.4, ease: 'power1.inOut' });
    gsap.to('.logo-success', { opacity: 1, duration: 0.3, delay: 0.4 + 0.2, ease: 'power1.inOut' });

    gsap.fromTo(
        '.claim-ui .single-m-grid',
        { scale: 0.5 },
        {
            scale: 1,
            duration: 0.8,
            stagger: 0.15,
            ease: 'pow2.Out',
            delay: base_delay + 0.3,

            onComplete: () => {
                setTimeout(() => {
                    var _dur = 0.6;
                    var _ease = 'power2.inOut';
                    gsap.to('.claim-ui .single-m-grid-0', { x: '100%', y: '50%', duration: _dur, ease: _ease });
                    gsap.to('.claim-ui .single-m-grid-1', { x: '0%', y: '50%', duration: _dur, ease: _ease });
                    gsap.to('.claim-ui .single-m-grid-2', { x: '-100%', y: '50%', duration: _dur, ease: _ease });
                    gsap.to('.claim-ui .single-m-grid-3', { x: '100%', y: '-50%', duration: _dur, ease: _ease });
                    gsap.to('.claim-ui .single-m-grid-4', { x: '0%', y: '-50%', duration: _dur, ease: _ease });
                    gsap.to('.claim-ui .single-m-grid-5', { x: '-100%', y: '-50%', duration: _dur, ease: _ease });

                    gsap.to('.claim-ui .single-m-grid', { opacity: 0, duration: _dur, ease: _ease, delay: 0.15 });

                    document.querySelector('.claim-ui').classList.add('blackout');
                }, 400);
            },
        }
    );

    // show final m after 6 Ms combine
    gsap.fromTo('.claim-ui .glow-m', { display: 'none', scale: 0.7, opacity: 0 }, { display: 'block', scale: 1, opacity: 1, duration: 0.8, ease: 'pow1.inOut', delay: 3.3 });
    gsap.fromTo('.claim-ui .final-m', { opacity: 0, scale: 0.7 }, { opacity: 1, scale: 1, duration: 0.8, ease: 'pow1.inOut', delay: 2.8 });

    // gsap.fromTo('.claim-ui .intro-text-row', { opacity: 0 }, { opacity: 1, duration: 0.7, ease: 'pow1.inOut', delay: 0.5 + base_delay });

    claimui_open = true;
}
function closeClaimUI() {
    playSoundEffect(sound_tap);
    gsap.to('.claim-ui', {
        opacity: 0,
        display: 'none',
        onComplete: () => {
            document.querySelector('.claim-ui').classList.remove('blackout');
            gsap.set('.claim-ui .glow-m', { display: 'none' });
        },
    });
    claimui_open = false;

    if (claim_progress == claim_total) {
        gsap.killTweensOf('.logo-basic');
        gsap.killTweensOf('.logo-success');
        gsap.killTweensOf('.logo-click');
        gsap.killTweensOf('.logo-touch');

        // closing claim ui after completed, show 'click' prompt again
        if (has_applied) {
            gsap.to('.logo-basic', { opacity: 1, duration: 0.3, delay: 0.3, ease: 'power1.inOut' });
            gsap.to('.logo-success', { opacity: 0, duration: 0.3, delay: 0.3, ease: 'power1.inOut' });
            gsap.to(window.innerWidth > 768 ? '.logo-click' : '.logo-touch', { opacity: 0, duration: 0.3, delay: 0.3 + 0.2, ease: 'power1.inOut' });
        } else {
            gsap.to('.logo-basic', { opacity: 0, duration: 0.3, delay: 0.3, ease: 'power1.inOut' });
            gsap.to('.logo-success', { opacity: 0, duration: 0.3, delay: 0.3, ease: 'power1.inOut' });
            gsap.to(window.innerWidth > 768 ? '.logo-click' : '.logo-touch', { opacity: 1, duration: 0.3, delay: 0.3 + 0.2, ease: 'power1.inOut' });
        }
    }
}

function handleSubmitClaim(slot) {
    submitResults();
}
function handleSuccess() {
    has_applied = true;
    params.alreadyApply = true;

    openClaimUI();

    let submit_button = document.createElement('div');
    submit_button.innerHTML = 'Submit Results';
    submit_button.setAttribute('class', ' button  submit-button');
    // document.querySelector('.claim-ui .claim-text').append(submit_button);

    submit_button.onclick = () => {
        alert('Submitted Successfully!');
        gsap.to(submit_button, {
            opacity: 0,

            onComplete: () => {
                submit_button.remove();

                let reset_button = document.createElement('div');
                reset_button.innerHTML = 'Restart Experience';
                reset_button.setAttribute('class', 'button reset-button');
                // document.querySelector('.claim-ui .claim-text').append(reset_button);

                reset_button.onclick = () => {
                    resetExperience();
                };
            },
        });
    };

    claim_complete = true;
}
function handleFail(msg) {
    alert(msg ? msg : 'fail');

    gsap.killTweensOf('.logo-basic');
    gsap.killTweensOf('.logo-success');
    gsap.killTweensOf('.logo-click');
    gsap.killTweensOf('.logo-touch');

    gsap.to('.logo-basic', { opacity: 1, duration: 0.3, delay: 0.3, ease: 'power1.inOut' });
    gsap.to('.logo-success', { opacity: 0, duration: 0.3, delay: 0.3 + 0.2, ease: 'power1.inOut' });
    gsap.to(window.innerWidth > 768 ? '.logo-click' : '.logo-touch', { opacity: 0, duration: 0.2, delay: 0, ease: 'power1.inOut' });

    closeClaimUI();

    // params.jumpto_steady();
    return;
}

document.querySelector('.claim-ui .close-content').onclick = () => {
    closeClaimUI();
    setClickedCloseButton(document.querySelector('.claim-ui .close-content'));
};

document.querySelector('.ui-progress').onclick = () => {
    // if (claim_progress != claim_total) return;
    // openClaimUI(); /// REMOVE THIS!
    if (claim_progress == claim_total && !has_applied) {
        handleSubmitClaim();
    } else {
        handleFail('이미 토큰 이벤트에 참여하셨습니다. 리워드에 대한 내용은 VR ROOM 이벤트 페이지에서 확인해주세요.');
        window.location = 'https://www.musinsa.com/app/content/s/event/vrcampaign';
    }
};
document.querySelector('.center-logo').onclick = () => {
    // if (claim_progress != claim_total) return;

    if (claim_progress == claim_total && !has_applied) {
        handleSubmitClaim();
    } else {
        handleFail('이미 토큰 이벤트에 참여하셨습니다. 리워드에 대한 내용은 VR ROOM 이벤트 페이지에서 확인해주세요.');
        window.location = 'https://www.musinsa.com/app/content/s/event/vrcampaign';
    }
};

function resetExperience() {
    closeClaimUI();
}

///////////////////////////
///////////////////////////

var volume = { v: 0.5 };
function toggleSound() {
    var uisound = document.querySelector('.ui-sound');
    playSoundEffect(sound_tap);
    if (uisound.getAttribute('data-sound') == 'on') {
        // sound on to off
        uisound.setAttribute('data-sound', 'off');
        gsap.to(volume, {
            v: 0,
            duration: 0.2,
            onUpdate: () => {
                bgm.volume = volume.v;
            },
            onComplete: () => {
                bgm.pause();
            },
        });
    } else {
        uisound.setAttribute('data-sound', 'on');
        bgm.play();
        gsap.to(volume, {
            v: 0.5,
            duration: 0.2,
            onUpdate: () => {
                bgm.volume = volume.v;
            },
        });
    }

    uisound.classList.add('clicked');
    setTimeout(() => {
        uisound.classList.remove('clicked');
    }, 600);
}

document.querySelector('.ui-sound').onclick = () => {
    toggleSound();
};

function populateCredits() {
    for (let i = 0; i < data.length; i++) {
        for (let y = 0; y < data[i].contents.length; y++) {
            var brandslug = data[i].contents[y].brandname.replace(/\s/g, '').toLowerCase();

            document.querySelector('.logos-wrap .inner').innerHTML += `<a href="${data[i].contents[y].brandshopurl}" target="_blank"><img src="https://image.msscdn.net/musinsaUI/campaign/vrshowroom/credits/img_logo_${brandslug}.png" /"></a> `;
            // document.querySelector('.logos-wrap .inner').innerHTML += `<a href="${data[i].contents[y].brandshopurl}" target="_blank"><img src="credits/img_logo_${brandslug}.png" /"></a> `;
        }
    }
}

////////////////
// API request
////////////////

// get vrhi from cookie
var has_applied = false;

var vrhi = ('; ' + document.cookie).split(`; vrhi=`).pop().split(';')[0];
if (vrhi.length == 0) {
    // if vrhi doesnt exist, generate random string on client side (for local dev use case)
    // vrhi = Math.random().toString(36).slice(2, 7);
    vrhi = 'novrhiincookie';
}
console.log('v', vrhi);

//  SUBMIT DATA

function submitResults() {
    if (claim_progress != claim_total || has_applied) return;
    console.log('submitting');
    axios
        .post('https://www.musinsa.com/contents/api/v1/vr-show-room/entry', {
            // .post('https://z5u0ud75o9.execute-api.ap-northeast-2.amazonaws.com/live/entry', {
            hashId: vrhi,
            //duplicate: true,
            // invalid: true,
        })
        .then(function (response) {
            if (response.status == 200) {
                console.log('submitted 200 response', response.status, response);
                if (response.data.data.success) {
                    handleSuccess();
                } else {
                    handleFail(response.data.data.message);
                    window.location = 'https://www.musinsa.com/app/content/s/event/vrcampaign';
                }
            } else {
                console.log('submit else response', response.status, response);
                handleFail(response.data.data.message);
                window.location = 'https://www.musinsa.com/app/content/s/event/vrcampaign';
            }
        })
        .catch(function (error) {
            console.log('submit error', error);
            handleFail(response.data.data.message);
            window.location = 'https://www.musinsa.com/app/content/s/event/vrcampaign';
        })
        .then(function () {
            // always executed
            // console.log('submit CHECK', has_applied);
        });
}

// checkApplyStateOnLoad();

if (is_debug) {
    document.body.classList.add('debug');
}

function handleVisibilityChange() {
    if (document.hidden) {
        // stopAllSounds();

        if (document.querySelector('.ui-sound').getAttribute('data-sound') == 'on') {
            bgm.pause();
        }
    } else {
        // playAllSounds();
        if (document.querySelector('.ui-sound').getAttribute('data-sound') == 'on') {
            bgm.play();
        }
    }
}

document.addEventListener('visibilitychange', handleVisibilityChange, false);
// openClaimUI();
